import React from 'react'
import moment from 'moment/moment'
import dateFormats from '../../../../utilities/dates/dateFormats'

const BkFlowStructuredSidebarStayDates = props => {
  const {
    urlData,
    toggleEditModal
  } = props

  return (
    <div className="bk-flow-structured-sidebar__row property-stay-dates">
      <button onClick={() => toggleEditModal()}>
        { urlData && urlData.startDate &&
          <span>{ moment(urlData.startDate).format(dateFormats.sidebar) }</span>
        }

        { urlData && urlData.endDate &&
          <span>{ moment(urlData.endDate).format(dateFormats.sidebar) }</span>
        }
      </button>
    </div>
  )
}

export default BkFlowStructuredSidebarStayDates



// WEBPACK FOOTER //
// ./src/components/structure/sidebar/elements/BkFlowStructuredSidebarStayDates.js